export default class gridSettingsClass {
  rowHeight;
  barHeight;
  deletedBarHeight;
  vehicles_width;
  hour_width;
  grid_height;
  grid_width;
  kellonajat_height;
  totalhours;
  hideVehicles;
  activeHourStart;
  activeHourEnd;
  paddingLeftRight;
  loadingDelay;
  keikkaCount;

  constructor() {
    this.version = 1.36; // UPDATE VERSION NUMBER IF YOU CHANGE ANYTHING
    this.vehicleRowHeight = 25; //30; // height of one vehicle row in pixels
    this.barHeight = 25; //30; // height of one bar in pixels inside row
    this.rowHeight = this.barHeight + 10; // height of one row in pixels
    this.deletedBarHeight = 26; //31; // height of one bar in pixels inside row
    this.kuskiHeight = 26; //31; // height of one kuski in pixels inside row
    this.vehicleGap = 0; // gap between vehicles in pixels

    this.vehicles_width = 100; // width of vehicles column in pixels
    this.grid_height = 600; // height of grid in pixels
    this.grid_width = 200; // width of grid in pixels
    this.kellonajat_height = 30; // height of kellonajat in pixels
    this.kellonajat_fontSize = "0.7rem"; // font size of kellonajat
    this.totalhours = 24; // total hours in grid
    this.hideVehicles = false; // hide vehicle if no keikka for it
    this.activeHourStart = 6; // do not show calendar hours before this
    this.activeHourEnd = 17; // do not show calendar hours after this

    this.vehicleColWidth = 100; // width of vehicle column in pixels
    this.driverColWidth = "60px"; // width of driver column in pixels
    this.keikatOffsetWidth = "200px";

    this.kellonajat_height = 60; // height of kellonajat in pixels
    this.keikkaMinWidth = 30; // minimum width of keikka in pixels
    this.keikkaFadeInTimeMs = 200; // time in milliseconds for keikka to fade in
    this.keikkaTransitionTime = "0.3s"; // time for keikka to transition
    this.vehicleTransitionTime = "0.5s"; // time for vehicle to transition
    this.kloTransitionTime = "0.2s"; // time for klo to transition
    this.isLoadingOpacity = 0.8; // opacity of grid when loading
    this.keikkaFirstHour = 6; // first hour of keikka
    this.keikkaLastHour = 17; // last hour of keikka
    this.kloInactiveHoursWidth_Units = 0; // width of klo in early and late hours
    this.kloActiveHoursWidth_Units = 100; // width of klo in active hours
    this.kloInactiveHoursWithKeikkaWidth_Units = 50; // width of klo in early and late hours with keikka
    this.timeParts = 5; // number of parts in one hour in grid
    this.sortId = 0; // sort id for vehicles. 0 = by sortNo, 1 = by vehicleNo, 2 = by vehicleName, 3 = by puomi

    this.vehicleFontSize = "0.9rem"; // font size of vehicle and driver info
    this.barFontSize = "1rem"; // font size of bar text

    this.renderDistance = 24; // number of hours to render, between 24 and 20*7*24=3360
    this.danceSimultaneousCount = 1; // number of keikka to move simultaneously during dance
    this.danceDelayMs = 450; // delay between moves during dance
    this.paddingLeftRight = 8; // padding left and right of row in pixels for vehicle and driver

    this.loadingDelay = 300; // delay before showing loading spinner

    this.keikkaCount = 0; // number of keikkas for selected timerange

    this.driversBoundingClient = null;
    this.addPxXS = -10;
    this.addPxS = -5;
    this.addPxM = 0;
    this.addPxL = 5;
    this.addPxXL = 10;

    this.settingTypes = {
      xsmall: {
        vehicleRowHeight: 25 + this.addPxXS,
        barHeight: 25 + this.addPxXS,
        rowHeight: 25 + 10 + this.addPxXS / 2,
        deletedBarHeight: 26 + this.addPxXS,
        kuskiHeight: 26 + this.addPxXS,
        vehicleGap: this.vehicleGap + this.addPxXS,
        barFontSize: "0.7rem",
        vehicles_width: 40,
        vehicleColWidth: 40,
      },
      small: {
        vehicleRowHeight: 25 + this.addPxS,
        barHeight: 25 + this.addPxS,
        rowHeight: 25 + 10 + this.addPxS / 2,
        deletedBarHeight: 26 + this.addPxS,
        kuskiHeight: 26 + this.addPxS,
        vehicleGap: this.vehicleGap + this.addPxS,
        barFontSize: "0.8rem",
        vehicles_width: 80,
        vehicleColWidth: 80,
      },
      medium: {
        vehicleRowHeight: 25 + this.addPxM,
        barHeight: 25 + this.addPxM,
        rowHeight: 25 + 10 + this.addPxM / 2,
        deletedBarHeight: 26 + this.addPxM,
        kuskiHeight: 26 + this.addPxM,
        vehicleGap: this.vehicleGap + this.addPxM,
        barFontSize: "1rem",
        vehicles_width: 100,
        vehicleColWidth: 100,
      },
      large: {
        vehicleRowHeight: 25 + this.addPxL,
        barHeight: 25 + this.addPxL,
        rowHeight: 25 + 10 + this.addPxL / 2,
        deletedBarHeight: 26 + this.addPxL,
        kuskiHeight: 26 + this.addPxL,
        vehicleGap: this.vehicleGap + this.addPxL,
        barFontSize: "1.2rem",
        vehicles_width: 120,
        vehicleColWidth: 120,
      },
      xlarge: {
        vehicleRowHeight: 25 + this.addPxXL,
        barHeight: 25 + this.addPxXL,
        rowHeight: 25 + 10 + this.addPxXL / 2,
        deletedBarHeight: 26 + this.addPxXL,
        kuskiHeight: 26 + this.addPxXL,
        vehicleGap: this.vehicleGap + this.addPxXL,
        barFontSize: "1.4rem",
        vehicles_width: 140,
        vehicleColWidth: 140,
      },
    };
  }

  static setSettingType = (gridSettings, type) => {
    // Ensure the type exists
    if (!gridSettings.settingTypes[type]) {
      console.log("Invalid setting type: ", type);
      return;
    }

    const settings = gridSettings.settingTypes[type];
    gridSettings.vehicleRowHeight = settings.vehicleRowHeight;
    gridSettings.barHeight = settings.barHeight;
    gridSettings.rowHeight = settings.rowHeight;
    gridSettings.deletedBarHeight = settings.deletedBarHeight;
    gridSettings.kuskiHeight = settings.kuskiHeight;
    gridSettings.vehicleGap = settings.vehicleGap;
    gridSettings.barFontSize = settings.barFontSize;
    gridSettings.vehicles_width = settings.vehicles_width;
    gridSettings.vehicleColWidth = settings.vehicleColWidth;
    gridSettingsClass.saveToLocalStorage(gridSettings);
    return gridSettings;
  };

  static loadFromLocalStorage = () => {
    let _gridSettings_fromLocalStorage = JSON.parse(localStorage.getItem("gridSettings"));
    let _gridSettings_class = new gridSettingsClass();
    if (
      !_gridSettings_fromLocalStorage ||
      _gridSettings_fromLocalStorage.version !== _gridSettings_class.version
    ) {
      return _gridSettings_class;
    }
    return _gridSettings_fromLocalStorage;
  };
  static loadDateFromLocalStorage = () => {
    try {
      let _date_fromLocalStorage = JSON.parse(localStorage.getItem("grid_date"));
      if (!_date_fromLocalStorage) {
        return new Date();
      }
      return new Date(_date_fromLocalStorage);
    } catch {
      return new Date();
    }
  };
  static saveDateToLocalStorage = (date) => {
    localStorage.setItem("grid_date", JSON.stringify(date));
  };

  static saveToLocalStorage = (gridSettings) => {
    gridSettings.kloInactiveHoursWithKeikkaWidth_Units = Number(
      gridSettings.kloInactiveHoursWithKeikkaWidth_Units
    );

    localStorage.setItem("gridSettings", JSON.stringify(gridSettings));
  };
}
